import { memo } from 'react';
import { cn } from 'root/src/client/v2/common/helpers/cn';
// One row of a redesign kebab / action popover: icon plus label, full width, sized to sit directly
// inside a `PopoverContent ... p-1`. Extracted from the creator profile dare card so the drop page
// cards can offer the same menu without a second copy of the styling.
export const RedesignMenuItem = memo(({ icon, label, onClick, destructive }) => (<button type="button" onClick={onClick} className={cn('flex w-full items-center gap-2.5 rounded-md px-2.5 py-2 text-sm transition-colors', destructive
        ? 'bg-destructive/10 text-destructive hover:bg-destructive/20'
        : 'text-foreground hover:bg-white/[0.06]')}>
		<span className={cn('flex', destructive ? 'text-destructive' : 'text-muted-foreground')}>{icon}</span>
		{label}
	</button>));
RedesignMenuItem.displayName = 'RedesignMenuItem';
